import cloneDeep from 'lodash/cloneDeep';

import { WorkcellConfig } from '../types';

export const removeExtraFields = (
  form: WorkcellConfig,
  baseline: WorkcellConfig,
  initial: WorkcellConfig
): WorkcellConfig => {
  const cleaned = cloneDeep(form);

  for (const [instrumentName, instrument] of Object.entries(cleaned)) {
    const relevantKeys = new Set([
      ...Object.keys(initial[instrumentName]?.config ?? {}),
      ...Object.keys(baseline[instrumentName]?.config ?? {}),
    ]);

    Object.keys(instrument.config).forEach((key) => {
      if (!relevantKeys.has(key)) {
        delete instrument.config[key];
      }
    });
  }

  return cleaned;
};
